import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const http = axios.create({ baseURL: API, timeout: 20000 });

export async function searchCompanies(q, page = 1, filters = {}) {
  const params = { q, page };
  if (filters.departement) params.departement = filters.departement;
  if (filters.section) params.section = filters.section;
  if (filters.etat) params.etat = filters.etat;
  const { data } = await http.get("/search", { params });
  return data;
}

export async function getCompany(siren) {
  const { data } = await http.get(`/company/${siren}`);
  return data;
}

export async function trackPrinterClick(siren, sourcePage) {
  try {
    await http.post("/track/printer-click", { siren, source_page: sourcePage });
  } catch (e) {
    /* mesure non bloquante */
  }
}

export async function getPrinterStats(token, days = 30) {
  const { data } = await http.get("/stats/printer-clicks", { params: { days }, headers: { "X-Stats-Token": token } });
  return data;
}

export default http;
